<template>
    <Modal v-model="modal"
           :title="`${title}-${$t('产品类别')}`"
           width="600"
           :mask-closable="false"
           @on-cancel="cancel">
        <Form ref="form"
              :model="formData"
              :rules="rules"
              :label-width="150"
              style="margin:10px 0 20px 0;">
            <FormItem :label="$t('产品类别名称')+'：'"
                      prop="name">
                <Input style="width: 80%"
                       :placeholder="$t('产品类别名称')"
                       v-model="formData.name" />
            </FormItem>
        </Form>
        <div class="product">
            <Transfer :data="data"
                      :titles="titles"
                      :target-keys="currData"
                      :list-style="listStyle"
                      filterable
                      :filter-method="filterMethod"
                      @on-change="handleChange"></Transfer>
        </div>

        <div slot="footer">
            <Button type="text"
                    @click="cancel">{{$t('取消')}}</Button>
            <Button type="primary"
                    :loading="loading"
                    @click="submit">
                <span v-show="!loading">{{operaType === 'add' ? $t('创建') : $t('保存')}}</span>
            </Button>
        </div>
    </Modal>
</template>

<script>
import API from '@/service/api'
export default {
    name: 'createcoupon',
    props: ['operaType', 'dataEdit'],
    data () {
        return {
            modal: false,
            loading: false,
            titles: [this.$t('未关联'), this.$t('已关联')],
            currData: [],
            listStyle: {
                width: '250px',
                height: '300px'
            },
            formData: {
                name: ''
            },
            data: [],
            editData: [],
            rules: {
                name: [
                    { required: true, message: this.$t('不能为空'), trigger: 'blur' }
                ]
            }
        }
    },
    computed: {
        title: function () {
            const newTitle = this.operaType === 'add' ? this.$i18n.t('创建') : this.$i18n.t('编辑')
            return newTitle
        }
    },
    methods: {
        openModal (data) {
            this.modal = true
            this.getProduct()
            // 编辑
            if (data) {
                this.editData = data
                this.formData.name = data.categoryName
                // 右侧数据
                this.currData = []
                if (data.products !== null) {
                    for (let i = 0; i < data.products.length; i++) {
                        this.currData.push(data.products[i].id)
                    }
                }
            }
        },
        onCheckChange (data) {
            this.checkedTree = data
        },
        // 初始化数据
        getProduct () {
            this.data = []
            this.axios.get(this.urlFormat(API.GET_PRODUCTS, false)).then(res => {
                this.loading = false
                for (let i = 0; i < res.dataList.length; i++) {
                    this.data.push({
                        key: res.dataList[i].id,
                        label: res.dataList[i].productName ? res.dataList[i].productName : '',
                        description: res.dataList[i].productName ? res.dataList[i].productName : ''
                    })
                }
            }).catch(e => {
                this.loading = false
            })
        },
        handleChange (newTargetKeys) {
            this.currData = newTargetKeys
        },
        filterMethod (data, query) {
            return data.label.indexOf(query) > -1
        },
        // 提交
        submit () {
            this.loading = true
            let axiosPath = ''
            if (this.editData.length === 0) {
                // 创建
                axiosPath = this.axios.post(this.urlFormat(API.PRODUCTS_CATEGORIES + '?name=' + this.formData.name + '&productIds=' + this.currData, false))
            } else {
            // 编辑
                axiosPath = this.axios.put(this.urlFormat(API.PRODUCTS_CATEGORIES_ID + '?name=' + this.formData.name + '&productIds=' + this.currData, false, [this.editData.id]))
            }
            axiosPath.then(res => {
                this.loading = false
                this.$emit('refresh')
                this.cancel()
            }).catch(e => {
                this.loading = false
            })
        },
        cancel () {
            this.modal = false
            this.editData = []
            this.data = []
            this.currData = []
            this.formData.name = ''
        }
    }
}
</script>
<style lang="less" scoped>
.scrollServer {
    width: 550px;
    height: 300px;
    overflow-y: auto;
}
.product {
    border-top: 1px dotted #eee;
    padding: 20px 0 0 0;
}
</style>
<style lang="less">
.scrollServer .visible {
    margin-left: 20px;
    margin-bottom: 15px;
}
</style>
